export default __webpack_public_path__ + "static/Ashandhi-dd98bdf583f4fb48b985cea9f81e604e.webp";